// import { useUserStore } from "~/stores/usuario_store";

let refreshPromise = null
let isRefreshing = false


async function tryRefreshToken() {
  if (refreshPromise) {
    return refreshPromise
  }

  const config = useRuntimeConfig()

  isRefreshing = true

  refreshPromise = $fetch(`${config.public.apiUrl}/fusuarios/refresh`, {
    method: "POST",
    credentials: "include",
    headers: buildHeaders(),
  })
    .then((response) => {
      const userStore = useUserStore()

      if (!response?.error && response?.access_token) {
        userStore.setUserToken(response.access_token)
        // console.log("REFRESH OK — atualizando token")
      }

      return response
    })
    .finally(() => {
      refreshPromise = null
      isRefreshing = false
    })

  return refreshPromise
}
// async function tryRefreshToken() {
//   console.log("TRY REFRESH INICIO")

//   const config = useRuntimeConfig()
//   console.log("CONFIG OK", config.public.apiUrl)

//   if (!refreshPromise) {
//     console.log("CHAMANDO REFRESH")

//     refreshPromise = $fetch(`${config.public.apiUrl}/fusuarios/refresh`, {
//       method: "POST",
//       credentials: "include",
//       headers: buildHeaders(),
//     }).then((response) => {
//       console.log("REFRESH OK", response)
//       const userStore = useUserStore()

//       if (!response?.error && response?.access_token) {
//         userStore.setUserToken(response.access_token)
//         console.log("REFRESH OK — atualizando token")
//       }
//       return response

//     }).finally(() => {
//       refreshPromise = null
//     })
//   }

//   return refreshPromise
// }

async function handleAuthError(error, retryFn = null) {
  // console.log("Tentando tratar erro de autenticação...");
  if (!error) return null

  const status =
    error?.response?.status ||
    error?.statusCode ||
    error?.data?.statusCode

  // só trata 401
  if (status !== 401) return null

  try {
    await tryRefreshToken()

    if (retryFn) {
      return await retryFn()
    }
  } catch (e) {
    const userStore = useUserStore()
    userStore.logout?.()

    if (process.client) {
      // window.location.href = "/login"
    }
  }

  return null
}

async function getAsyncData(url, userToken, dadosSend = null, apelido = "default") {
  const config = useRuntimeConfig()

  const request = async () => {
    return await $fetch(`${config.public.apiUrl}${url}`, {
      server: true,
      credentials: "include",
      headers: buildHeaders(userToken),
      query: dadosSend ?? null,
    })
  }

  try {
    const response = await request()

    return {
      data: typeof response === "string" ? JSON.parse(response) : response,
      error: null,
      status: 200,
    }
  } catch (error) {
    const retry = await handleAuthError(error, request)
    if (retry) {
      return {
        data: typeof retry === "string" ? JSON.parse(retry) : retry,
        error: null,
        status: 200,
      }
    }

    return {
      data: error?.data ?? null,
      error,
      status: error?.response?.status,
    }
  }
}



// async function getAsyncData(url, userToken, dadosSend = null, apelido = "default") {
//   const config = useRuntimeConfig();

//   const { data, error, status, refresh } = await useAsyncData(
//     apelido,
//     () =>
//       $fetch(`${config.public.apiUrl}${url}`, {
//         server: true,
//         credentials: "include",
//         headers: buildHeaders(userToken),
//         query: dadosSend ?? null,
//       }),
//     {
//       transform: (response) => {
//         if (typeof response == "string") {
//           return JSON.parse(response);
//         } else {
//           return response;
//         }
//       },
//     }
//   );

//   return { data: data.value, status, error, refresh };
// }

async function getAsync(url, userToken, apelido) {
  const config = useRuntimeConfig();

  const { data, pending, error, refresh } = await useAsyncData(
    apelido,
    () =>
      $fetch(`${config.public.apiUrl}${url}`, {
        credentials: "include",
        server: true,
        headers: buildHeaders(userToken),
      }),
    {
      transform: (response) => {
        if (typeof response == "string") {
          return JSON.parse(response);
        } else {
          return response;
        }
      },
    }
  );

  return { data, pending, error, refresh };
}

async function get(url, userToken, dadosSend = null) {
  const config = useRuntimeConfig()

  const request = async () => {
    const data = await $fetch(url, {
      method: "GET",
      baseURL: config.public.apiUrl,
      headers: buildHeaders(userToken),
      credentials: "include",
      query: dadosSend ?? null,
    })

    // mantém o mesmo "shape" que seu sistema já usa
    return { data, pending: false }
  }

  try {
    return await request()
  } catch (error) {
    const retry = await handleAuthError(error, request)
    if (retry) return retry

    // mantém compatibilidade (igual você já fazia)
    return { data: error?.data, pending: false, error }
  }
}


// async function get(url, userToken, dadosSend = null) {
//   const config = useRuntimeConfig();

//   let c = {
//     method: "GET",
//     baseURL: config.public.apiUrl,
//     headers: buildHeaders(userToken),
//     credentials: "include",
//     query: dadosSend ?? null,
//   };

//   // console.log(c);

//   let _ret = null;

//   await useFetch(url, c)
//     .then(function (response) {
//       if (response.data.value.fatal) {
//         window.location.href = "/error";
//         return;
//       }
//       _ret = { data: response.data.value, pending: response.pending.value };
//     })
//     .catch((error) => {
//       handleAuthError(error)
//       _ret = error.data
//     });

//   // console.log(_ret);

//   return _ret;
// }

async function post(url, dadosSend, userToken = null) {
  const config = useRuntimeConfig();

  const request = async () => {
    return await $fetch(url, {
      method: "POST",
      baseURL: config.public.apiUrl,
      headers: buildHeaders(userToken),
      credentials: "include",
      body: JSON.stringify(dadosSend),
    })
  }

  try {
    return await request()
  } catch (error) {
    const retry = await handleAuthError(error, request)
    if (retry) return retry
    return error?.data
  }
}


//Envia formulario com arquivos para upload
//Usar somente quando realmente for necessario
//a ideia é não fazer upload desta forma
async function postComArquivo(url, dadosSend, userToken = null) {
  const config = useRuntimeConfig();

  let c = {
    method: "POST",
    baseURL: config.public.apiUrl,
    headers: buildHeaders(userToken),
    credentials: "include",
    body: dadosSend,
  };

  let _ret = null;

  await useFetch(url, c)
    .then(function (response) {
      if (response.data.value.fatal) {
        window.location.href = "/error";
        return;
      }

      _ret = {
        data: response.data.value,
        pending: response.pending.value,
        error: response.error.value,
      };
    })
    .catch((error) => {
      handleAuthError(error)
      _ret = error.data;
    });

  return _ret;
}

async function postIMG(url, dadosSend) {
  const config = useRuntimeConfig();

  const c = {
    baseURL: config.public.imagemUrl,
    method: "POST",
    headers: {
      Authorization: `Bearer ${config.public.API_IMSGEMS_TOKEN}`,
      Accept: "application/json",
      Credentials: "include",
    },
    body: dadosSend,
  };

  let _ret = null;

  try {
    const response = await useFetch(url, c);

    if (response.data.value?.fatal) {
      window.location.href = "/error";
      return;
    }

    // =====================================================
    // 🔥 NORMALIZAÇÃO OOLOJA (CRÍTICA)
    // =====================================================
    let payload = response.data.value;

    // 🧠 se veio string JSON, faz parse seguro
    if (typeof payload === "string") {
      try {
        payload = JSON.parse(payload);
      } catch (e) {
        console.error("[postIMG] Falha ao fazer JSON.parse:", e);
      }
    }

    // 🧠 se veio no formato { image: {...} }
    if (payload?.image) {
      payload = payload.image;
    }

    _ret = {
      data: payload,
      pending: response.pending.value,
      error: response.error.value,
    };

  } catch (error) {
    handleAuthError(error);
    _ret = error?.data ?? error;
  }

  return _ret;
}

async function deleteIMG(url, dadosSend) {
  const config = useRuntimeConfig();

  let c = {
    baseURL: config.public.imagemUrl,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${config.public.API_IMSGEMS_TOKEN}`,
      Accept: "application/json",
      Credentials: "include",
    },
  };

  let _ret = null;

  await useFetch(url, c)
    .then(function (response) {
      if (response.data.value.fatal) {
        window.location.href = "/error";
        return;
      }
      _ret = {
        data: response.data.value,
        pending: response.pending.value,
        error: response.error.value,
      };
    })
    .catch((error) => {
      handleAuthError(error)
      _ret = error.data;
    });

  return _ret;
}

async function useFetchPost(url, dadosSend, userToken = null) {
  const config = useRuntimeConfig();

  let c = {
    method: "POST",
    baseURL: config.public.apiUrl,
    headers: buildHeaders(userToken),
    credentials: "include",
    body: JSON.stringify(dadosSend),
  };

  let _ret = null;

  await useFetch(url, c)
    .then(function (response) {
      if (response.data.value.fatal) {
        window.location.href = "/error";
        return;
      }
      _ret = {
        data: response.data.value,
        pending: response.pending.value,
        error: response.error.value,
      };
    })
    .catch((error) => {
      handleAuthError(error)
      _ret = error.data;
    });
  return _ret;
}

async function del(url, dadosSend, userToken = null) {
  const config = useRuntimeConfig();

  let c = {
    method: "DELETE",
    baseURL: config.public.apiUrl,
    headers: buildHeaders(userToken),
    credentials: "include",
    body: JSON.stringify(dadosSend),
  };

  let _ret = null;
  await useFetch(url, c)
    .then(function (response) {
      if (response.data.value.fatal) {
        window.location.href = "/error";
        return;
      }
      _ret = {
        data: response.data.value,
        pending: response.pending.value,
        error: response.error.value,
      };
    })
    .catch((error) => {
      handleAuthError(error)
      _ret = error.data;
    });
  return _ret;
}

async function put(url, dadosSend, userToken = null) {
  const config = useRuntimeConfig();

  let c = {
    method: "PUT",
    baseURL: config.public.apiUrl,
    headers: buildHeaders(userToken),
    credentials: "include",
    body: JSON.stringify(dadosSend),
  };

  let _ret = null;
  await useFetch(url, c)
    .then(function (response) {
      if (response.data.value.fatal) {
        window.location.href = "/error";
        return;
      }
      _ret = {
        data: response.data.value,
        pending: response.pending.value,
        error: response.error.value,
      };
    })
    .catch((error) => {
      handleAuthError(error)
      _ret = error.data;
    });
  return _ret;
}

function buildHeaders(userToken = null) {
  const config = useRuntimeConfig()
  const userStore = useUserStore()

  const token = userToken || userStore.user.token

  // console.log("BUILD HEADERS", { token })

  const headers = {
    Accept: "application/json",
    "X-App-Token": config.public.token,
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  return headers
}

// function buildHeaders(userToken = null) {
//   const config = useRuntimeConfig()

//   const headers = {
//     Accept: "application/json",
//     "X-App-Token": config.public.token, // TOKEN_FIXO
//   }

//   if (userToken) {
//     headers.Authorization = `Bearer ${userToken}` // JWT
//   }

//   return headers
// }

export default { get, getAsyncData, post, del, put, getAsync, useFetchPost, postIMG, deleteIMG, postComArquivo };
